import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = ({ withFooter = true }) => (
  <div className="flex min-h-screen flex-col">
    <Header />
    <main className="flex-1"><Outlet /></main>
    {withFooter && <Footer />}
  </div>
);
